module.exports = __webpack_public_path__ + "img/settingIcon.2f6c16b6.svg";